import "../Styles/Contact.css";
import Lottie from "lottie-react";
import doneAnimation from "../animation/done.json";
import contactAnimation from "../animation/contact.json";
import { useForm, ValidationError } from '@formspree/react';



const Contact = () => {
  const [state, handleSubmit] = useForm("mvojnzrd");

  return (
    <>

      <section className="contact-us" id='Contact-Me' >
        <h1 className="title">
          <span className="icon-envelope"> </span>
          Contact Me
        </h1>
        <p className="sub-title" style={{'text-transform': 'capitalize'}}>
          Contact Me for more information and Get notified when I publish
          something new.
        </p>

        <div style={{ justifyContent: "space-between" }} className="flex">
          <form onSubmit={handleSubmit} className="">
            <div className="flex">
              <label htmlFor="email">Email Address:</label>
              <input
                autoComplete="off"
                required
                type="email"
                name="email"
                id="email"
              />
              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
              />

            </div>

            <div className="flex" style={{ marginTop: "24px" }}>
              <label htmlFor="message">Your message:</label>
              <textarea required name="message" id="message"></textarea>
              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
              />
            </div>

            <button type="submit" disabled={state.submitting} className="submit">
              {state.submitting ? "Sending..." : "Send"}
            </button>

            {state.succeeded && (
              <p
                className="flex felicitation"
                style={{ fontSize: "18px", marginTop: "1.7rem" }}
              >
                <Lottie
                  loop={false}
                  style={{ height: 37 }}
                  animationData={doneAnimation}
                />
                Your message has been sent successfully 👌
              </p>
            )}

          </form>
          <div className=" animation">
            <Lottie
              className="contact-animation"
              style={{ height: 500 }}
              animationData={contactAnimation}
            />
          </div>
        </div>
      </section>
    </>

  );
};

export default Contact;
